/**
 * VoiceStudio Component
 *
 * Modern professional voice selection interface with:
 * - Split-panel design (library browser + preview studio)
 * - Access to 5,000+ voices from ElevenLabs
 * - Real-time waveform visualization
 * - Advanced voice settings and customization
 */

import { VoiceStudioPro } from './VoiceStudioPro';

interface VoiceStudioProps {
  userId: string;
  userProfile: {
    gender?: string;
    firstName?: string;
    lastName?: string;
  };
  currentVoiceId?: string | null;
  currentAudioUrl?: string | null;
  currentGreeting?: string | null;
  onVoiceConfigured?: () => void;
}

export function VoiceStudio(props: VoiceStudioProps) {
  // Delegate to the new professional Voice Studio Pro component
  return <VoiceStudioPro {...props} />;
}
